import { fetchMerchant, getRates } from "../utils/api";
import { useState, useEffect } from "react";
import { MerchantRate } from "../utils/types";

export const useMerchants = () => {
  const [merchants, setMerchants] = useState<
    {
      name: string;
      id: number;
      terminals: [];
    }[]
  >([]);
  const [rates, setRates] = useState<MerchantRate>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState("");
  const fetchData = async () => {
    setLoading(true);
    try {
      const [ratesRes, merchantsRes] = await Promise.all([
        getRates(),
        fetchMerchant(),
      ]);

      setMerchants(merchantsRes.data);
      setRates(ratesRes.data);
    } catch (error) {
      setError("Ошибка при загрузке мерчантов");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  return {
    merchants,
    loading,
    error,
    rates,
    setRates,
    fetchData,
  };
};
